import { Moment } from "moment";

import moment = require("moment");
import { camelCase } from "lodash";

import { getAdminProfessionDisplayName, Profession } from "@teamprevent/common/adminUser/models";
import { getFeatureToggles } from "@teamprevent/common/getFeatureToggles";
import * as FeatureToggleNames from "@teamprevent/common/featureToggleNames";

import { MedicalTypeId, MedicalOutcome, DecisionPendingClarification } from "../models";

type EmployeeRecordModel = {
    name: string;
    dateOfBirth: Moment;
    jobTitle: string;
    orgStructure: string[];
    workGroups: string[];
}

export type CertificateMedicalOutcomeModel = {
    dateCreated: Moment;
    customerNotes: string;
    medicalTypeId: MedicalTypeId;
    outcome: keyof typeof MedicalOutcome;
    recallYears?: number;
    decisionPendingClarification: DecisionPendingClarification;
}

export type CertificateModel = {
    customerName: string;
    customerPhoneNumber: string;
    customerEmailAddress: string;
    employee: EmployeeRecordModel;
    consultationDate: Moment;
    reviewDate: Moment;
    outcomes: CertificateMedicalOutcomeModel[];
    reviewedBy: ClinicianModel;
    recalls: RecallModel[];
    ppqDeclarationReviewNotes: string[];
}

export type ClinicianModel = {
    id: string;
    name: string;
    profession: string;
    qualification: string;
}

export type RecallModel = {
    date: Moment;
    medicals: MedicalTypeId[];
}

export const parseCertificateModel = (model: CertificateModel): CertificateModel => ({
    ...model,
    consultationDate: moment(model.consultationDate),
    reviewDate: moment(model.reviewDate),
    outcomes: model.outcomes.map(o => ({ ...o, outcome: camelCase(o.outcome) as keyof typeof MedicalOutcome, dateCreated: moment(o.dateCreated) })),
    employee: {
        ...model.employee,
        dateOfBirth: moment(model.employee.dateOfBirth)
    },
    recalls: model.recalls.map(r => ({ ...r, date: moment(r.date) })),
    reviewedBy: getFeatureToggles()[FeatureToggleNames.EnableHealthSurveillanceCrs11_3]
        ? {
            ...model.reviewedBy,
            profession: getAdminProfessionDisplayName(model.reviewedBy.profession as Profession),
        }
        : model.reviewedBy
});
